<template>
  <div v-if="fetchingLinks" class="text-center text-blue-400 my-8">
    <base-loading class="block text-3xl" />
    Loading links
  </div>
  <div
    v-else-if="links.length === 0"
    class="text-center bg-white text-blue-400 py-8 px-4"
  >
    <p class="mb-6">No links were created yet</p>

    <base-button @click="$router.push({ name: 'create-link' })" size="large">
      Create a link
    </base-button>
  </div>
  <dashboard-links-filters v-else :links="links" :userId="userId" class="mb-8">
    <template #before-links="{ filters, hasLinks }">
      <dashboard-links-export
        v-if="hasLinks"
        :filters="filters"
        :userId="userId"
        class="mb-6"
      />
    </template>
    <template #default="{ links }">
      <div v-if="links.length === 0" class="bg-white text-blue-400 py-8 px-4">
        No matching links found
      </div>
      <ul v-else>
        <li v-for="link in links" :key="link.id" class="mb-3">
          <dashboard-links-item :link="link" />
        </li>
      </ul>
    </template>
  </dashboard-links-filters>
</template>

<script>
import { mapState } from 'vuex';
import { isAfter } from 'date-fns';
import DashboardLinksFilters from './components/DashboardLinksFilters.vue';
import DashboardLinksItem from './components/DashboardLinksItem';
import DashboardLinksExport from './components/DashboardLinksExport';

export default {
  components: {
    DashboardLinksItem,
    DashboardLinksFilters,
    DashboardLinksExport,
  },
  data() {
    return {
      fetchingLinks: false,
      refreshingCache: false,
      links: [],
    };
  },
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
      currentSegmentId: (state) => state.company.segment.currentId,
      userId: (state) => state.auth.user.pk,
    }),
  },
  watch: {
    currentSegmentId(current, prev) {
      if (current !== prev) {
        this.fetchLinks();
      }
    },
  },
  mounted() {
    this.fetchLinks();
  },
  methods: {
    setLinks(data) {
      this.links = data.sort((a, b) =>
        isAfter(new Date(a.created_at), new Date(b.created_at)) ? -1 : 1
      );
    },
    async fetchLinks() {
      this.fetchingLinks = true;
      const {
        data,
        request: { fromCache },
      } = await this.$api.get(
        `companies/${this.currentCompanyId}/segments/${this.currentSegmentId}/tracking_links/`
      );
      if (fromCache) {
        this.refreshCache();
      }
      this.setLinks(data);
      this.fetchingLinks = false;
    },
    async refreshCache() {
      this.refreshingCache = true;
      const { data } = await this.$api.get(
        `companies/${this.currentCompanyId}/segments/${this.currentSegmentId}/tracking_links/`,
        {
          cache: {
            ignoreCache: true,
          },
        }
      );
      this.setLinks(data);
      this.refreshingCache = false;
    },
  },
};
</script>
